import React from "react";
import Box from "@mui/material/Box";

export default function Progress({ step, totalSteps }) {
  const progressPercentage = (step / totalSteps) * 100;
  
  return (
    <Box position="relative">
      <Box
        position="absolute"
        width={`${progressPercentage}%`}
        borderTop="2px solid"
        borderColor="#1976d2"
      />
      <Box borderTop="2px solid #d5d5d5" />
    </Box>
  );
}
